import styled from 'styled-components';
import { Button as MuiButton, ButtonProps } from '@material-ui/core';
import { MouseEventHandler } from 'react';

import AddIcon from '@material-ui/icons/Add';

interface IButtonStyled {
  bgColor?: 'primary' | 'secondary';
  fullWidth?: boolean;
}

const ButtonStyled = styled(MuiButton)<IButtonStyled>`
  &.MuiButtonBase-root {
    background: ${({bgColor}) => bgColor === 'secondary' ? 'var(--color-gray)' : 'var(--color-red)'};
    color: var(--white);
    width: 100%;
    height: 40px;
    font-size: 1.2rem;
    text-transform: uppercase;

    @media(min-width: 960px) {
      width: ${({fullWidth}) => fullWidth ? '100%' : '155px'};
    }

    @media(min-width: 1920px) {
      font-size: 1.4rem;
      height: 48px;
      width: 179px;
    }
  }
  &.MuiButton-root:hover {
    background-color: ${({bgColor}) => bgColor === 'secondary' ? 'var(--color-gray-dark)' : 'var(--color-red-dark)'};
    cursor: pointer;
  }
  &.Mui-disabled {
    background-color: var(--grayLv6);
  }
`;

interface ButtonAndIconProps extends ButtonProps {
  bgColor?: 'primary' | 'secondary';
  fullWidth?: boolean;
  icon: string;
  label: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const ButtonAndIcon = ({fullWidth, bgColor, icon, label, onClick, ...rest}: ButtonAndIconProps) => {
  return (
    <ButtonStyled
      {...rest}
      fullWidth={fullWidth}
      bgColor={bgColor}
      onClick={onClick}
      disabled={rest.disabled}
    >
      {icon === 'plus' && <AddIcon fontSize="large" style={{ marginRight: '8px' }} />}
      {label}
    </ButtonStyled>
  )
}